import React, { createContext, useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { currentShoot } from "../../../../utils/currentShoot"
import {
  deleteDealMemoItem,
  getExpensesTypesList,
  deleteAdditionalBillApprovalItem,
  getClassesList,
} from "../../../../actions/billing"
import { useDispatch, useSelector } from "react-redux"
import { toggleClickConfirmationDialog } from "../../../../actions/billingDialogs"
import { diff } from "deep-object-diff"

//Original Columns
export const columns = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        title: "Qty.",
        dataProperty: "quantity",
        gridSize: "80px",
      },
      {
        title: "Rate($)",
        dataProperty: "actual_rate",
        gridSize: "80px",
      },
      {
        title: "Total($)",
        dataProperty: "total",
        gridSize: "80px",
      },
    ],
    dataProperty: "expenses",
  },
]
//Columns for the client side views
export const clientColumns = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        title: "Qty.",
        dataProperty: "quantity",
        gridSize: "80px",
      },
      {
        title: "Rate($)",
        dataProperty: "actual_rate",
        gridSize: "80px",
      },
      {
        title: "Total($)",
        dataProperty: "total",
        gridSize: "80px",
      },
    ],
    dataProperty: "expenses",
  },
]
export const mobileClientColumns = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        dataProperty: "quantity",
      },
      {
        dataProperty: "rate",
      },
      {
        dataProperty: "total",
      },
    ],
    dataProperty: "expenses",
  },
]
//These columns are used in the Admin Deal Memo view
// 1) Desktop (non-mobile) - select is used to subdivide the type_name column
export const editableDealMemoColumns = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        title: "",
        dataProperty: "select",
      },
      {
        title: "Qty.",
        dataProperty: "quantity",
        gridSize: "100px",
      },
      {
        title: "Rate($)",
        dataProperty: "actual_rate",
        gridSize: "100px",
      },
      {
        title: "Total($)",
        dataProperty: "total",
        gridSize: "100px",
      },
    ],
    dataProperty: "expenses",
    editable: true,
  },
]
// 2) Mobile
export const mobileEditableDealMemoColumns = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        dataProperty: "quantity",
      },
      {
        dataProperty: "actual_rate",
      },
      {
        dataProperty: "total",
      },
    ],
    dataProperty: "expenses",
    editable: true,
  },
]
//These columns are used in the Deal Memo Crew Side Mobile View
export const crewMobileColumns = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "quantity",
      },
      {
        dataProperty: "actual_rate",
      },
      {
        dataProperty: "total",
      },
    ],
    dataProperty: "expenses",
  },
]
//These columns are used in the Crew side Bill Approval Mobile View
export const editableCrewMobileColumns = [
  {
    columns: [
      {
        title: "Additional Item",
        dataProperty: "quantity",
      },
      {
        dataProperty: "actual_rate",
      },
      {
        dataProperty: "total",
      },
    ],
    dataProperty: "expenses",
    editable: true,
  },
]
//These are columns for the admin estimate
// 1) Desktop Admin Estimate
export const estimateCardBillingColumns = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        title: "Qty.",
        dataProperty: "quantity",
        gridSize: "50px",
      },
      {
        title: "Rate($)",
        dataProperty: "actual_rate",
        gridSize: "90px",
      },
      {
        title: "Markup",
        dataProperty: "client_rate",
        gridSize: "90px",
      },
      {
        title: "Discount($)",
        dataProperty: "discount",
        gridSize: "90px",
      },
      {
        title: "Total($)",
        dataProperty: "total",
        gridSize: "90px",
      },
    ],
    dataProperty: "expenses",
    editable: true,
  },
]
// 2) Mobile Admin Estimate
export const mobileEstimateColumns = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        dataProperty: "quantity",
      },
      {
        dataProperty: "actual_rate",
      },
      {
        dataProperty: "client_rate",
      },
      {
        dataProperty: "discount",
      },
      {
        dataProperty: "total",
      },
    ],
    dataProperty: "expenses",
    editable: true,
  },
]

//These are the columns for mobile admin bill apprioval side
// 1) Admin Dekstop bill approval - original columns locked, additional columns editable
export const billApprovalColumns = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        title: "Qty.",
        dataProperty: "quantity",
        gridSize: "50px",
      },
      {
        title: "Rate($)",
        dataProperty: "actual_rate",
        gridSize: "80px",
      },
      {
        title: "Markup",
        dataProperty: "client_rate",
        gridSize: "100px",
      },
      {
        title: "Discount($)",
        dataProperty: "discount",
        gridSize: "90px",
      },
      {
        title: "Total($)",
        dataProperty: "total",
        gridSize: "80px",
      },
    ],
    dataProperty: "expenses",
  },
  {
    columns: [
      {
        title: "Additional Items",
        dataProperty: "type_name",
      },
      {
        title: "Qty.",
        dataProperty: "quantity",
        gridSize: "50px",
      },
      {
        title: "Rate($)",
        dataProperty: "actual_rate",
        gridSize: "80px",
      },
      {
        title: "Markup",
        dataProperty: "client_rate",
        gridSize: "100px",
      },
      {
        title: "Discount($)",
        dataProperty: "discount",
        gridSize: "90px",
      },
      {
        title: "Total($)",
        dataProperty: "total",
        gridSize: "80px",
      },
    ],
    editable: true,
    dataProperty: "additional_expenses",
  },
]
// 2) Admin phone & tablet bill approval - original columns locked, additional columns editable
export const mobileBillApprovalColumns = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        dataProperty: "quantity",
      },
      {
        dataProperty: "actual_rate",
      },
      {
        dataProperty: "client_rate",
      },
      {
        dataProperty: "discount",
      },
      {
        dataProperty: "total",
      },
    ],
    dataProperty: "expenses",
  },
  {
    columns: [
      {
        title: "Additional Item",
        dataProperty: "type_name",
      },
      {
        dataProperty: "quantity",
      },
      {
        dataProperty: "actual_rate",
      },
      {
        dataProperty: "client_rate",
      },
      {
        dataProperty: "discount",
      },
      {
        dataProperty: "total",
      },
    ],
    editable: true,
    dataProperty: "additional_expenses",
  },
]
//These are the mobile invoice columns for admin side

export const editableColumns = [{ ...columns[0], editable: true }]

export const clientColumnsWithDiscount = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        title: "Qty",
        dataProperty: "quantity",
      },
      {
        title: "Rate",
        dataProperty: "",
      },
      {
        title: "Discount($)",
        dataProperty: "discount",
      },
      {
        title: "Total($)",
        dataProperty: "total",
      },
    ],
    dataProperty: "expenses",
  },
]

export const invoiceColumns = [
  { ...estimateCardBillingColumns[0], editable: false },
]
export const mobileInvoiceColumns = [
  { ...mobileEstimateColumns[0], editable: false },
]

export const columnsMarkupAndDiscount = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        title: "Qty.",
        dataProperty: "quantity",
        gridSize: "90px",
      },
      {
        title: "Rate($)",
        dataProperty: "actual_rate",
        gridSize: "90px",
      },
      {
        title: "Markup",
        dataProperty: "client_rate",
        gridSize: "90px",
      },
      {
        title: "Discount($)",
        dataProperty: "discount",
        gridSize: "90px",
      },
      {
        title: "Total($)",
        dataProperty: "total",
        gridSize: "90px",
      },
    ],
    dataProperty: "expenses",
  },
]

export const editableColumnsMarkupAndDiscount = [
  {
    ...columnsMarkupAndDiscount[0],
    editable: true,
  },
]

//solo unlabeled, unsized for mobile & tablet
export const mobileSoloColumns = [
  {
    columns: [
      {
        title: "Item",
        dataProperty: "type_name",
      },
      {
        dataProperty: "quantity",
      },
      {
        dataProperty: "actual_rate",
      },
      {
        dataProperty: "client_rate",
      },
      {
        dataProperty: "discount",
      },
      {
        dataProperty: "total",
      },
    ],
    dataProperty: "expenses",
  },
]

// solo EDITABLE - unlabeled, unsized for mobile & tablet
export const editableMobileSoloColumns = [
  { ...mobileSoloColumns[0], editable: true },
]

const BillingContext = createContext()
export default BillingContext

export const BillingContainer = ({ children, ...props }) => {
  const id = props.shootId
  const dispatch = useDispatch()
  const history = children.props.history
  const blockRef = useRef()
  const [currentShootData, setCurrentShootData] = useState([])
  const [loading, setLoading] = useState(false)
  const [unsavedState, setUnsavedState] = useState([])
  const [unsavedErrorBorder, setUnsavedErrorBorder] = useState(false)
  const usersRolesArray = useSelector(state => state.billing.usersRolesArray)
  const usersRolesArrayInitialValues = useSelector(
    state => state.billing.usersRolesArrayInitialValues
  )
  const expensesTypesList = useSelector(
    state => state.billing.expensesTypesList
  )
  const classesList = useSelector(state => state.billing.classesList)

  const [initialState, setInitialState] = useState(usersRolesArrayInitialValues)

  const unsavedData = diff(usersRolesArrayInitialValues, usersRolesArray)
  let roleKeys = Object.keys(unsavedData)
  useEffect(
    () => {
      if (unsavedState.length > 0) {
        blockRef.current = {
          unblock: history.block(tx => {
            setUnsavedErrorBorder(true)
            const moveToNextScreen = () => {
              setUnsavedState([])
              setUnsavedErrorBorder(false)
              if (roleKeys.length > 0) {
                roleKeys.forEach(
                  key =>
                    unsavedData[Number(key)].expenses
                      ? Object.values(
                          unsavedData[Number(key)].expenses
                        ).forEach(expense => {
                          unsavedState.includes(`e${expense.expense_id}`) &&
                            dispatch(
                              deleteDealMemoItem(
                                expense.expense_id,
                                expense.shootRoleId
                              )
                            )
                          setUnsavedState(oldState => {
                            return [
                              ...oldState
                                .map(x => {
                                  if (x !== `e${expense.expense_id}`) {
                                    return x
                                  }
                                })
                                .filter(x => x),
                            ]
                          })
                        })
                      : Object.values(
                          unsavedData[Number(key)].additional_expenses
                        ).forEach(expense => {
                          unsavedState.includes(
                            `a${expense.additional_expense_id}`
                          ) &&
                            dispatch(
                              deleteAdditionalBillApprovalItem(
                                expense.additional_expense_id,
                                expense.shootRoleId
                              )
                            )
                          setUnsavedState(oldState => {
                            return [
                              ...oldState
                                .map(x => {
                                  if (
                                    x !== `a${expense.additional_expense_id}`
                                  ) {
                                    return x
                                  }
                                })
                                .filter(x => x),
                            ]
                          })
                        })
                )
              }
              blockRef.current.unblock()
              history.push(tx.pathname)
            }
            let data = {
              action: "leave without saving",
              confirmationFunc: moveToNextScreen,
            }
            dispatch(toggleClickConfirmationDialog(true, data))
            return false
          }),
        }
      } else {
        blockRef.current && blockRef.current.unblock()
      }
    },
    [unsavedState]
  )

  // pulling all shoots data from redux
  const myShootsList = useSelector(state => state.shoots.shoots)

  // setting current shoot data
  useEffect(
    () => {
      if (id && myShootsList) {
        setCurrentShootData(currentShoot(id, myShootsList))
      }
    },
    [id, myShootsList]
  )

  // load expense types list for use in autocomplete
  useEffect(() => {
    if (expensesTypesList.length === 0) {
      dispatch(getExpensesTypesList())
    }
  }, [])

  // load expense types list for use in autocomplete
  useEffect(() => {
    if (classesList.length === 0) {
      dispatch(getClassesList())
    }
  }, [])

  return (
    <BillingContext.Provider
      value={{
        loading,
        setLoading,
        currentShootData,
        setCurrentShootData,
        unsavedState,
        setUnsavedState,
        unsavedErrorBorder,
        setUnsavedErrorBorder,
        initialState,
        setInitialState,
      }}
    >
      {children}
    </BillingContext.Provider>
  )
}

BillingContainer.propTypes = {
  children: PropTypes.node,
}
